import { Menu, Settings, Search } from "lucide-react";
import { SeericButton } from "../SeericButton/SeericButton";
import SeericInput from "../SeericInput/SeericInput";
import "./Navbar.css";
import { useAuthData } from "@/hooks/useAuthData";
import { motion } from "framer-motion";
import fixTextEncoding from "@/utils/textEncoding";
import { InfoTooltip } from "../InfoToolTip/InfoTooltip";
import { useIsMobile } from '@/hooks/useIsMobile';
import { SITE_NAME_CAPITALIZED } from "@/constants/site";
import { useMemo } from "react";
import { formatUserGreeting } from "@/utils/formatUserGreeting";


interface NavbarProps {
  onMenuClick: () => void;
  sidebarOpen: boolean;
  searchValue?: string;
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchSubmit?: () => void;
  loading?: boolean;
}

export default function Navbar({
  onMenuClick,
  sidebarOpen,
  searchValue = "",
  onSearchChange = () => { },
  onSearchSubmit = () => { },
  loading = false,
}: NavbarProps) {
  const { user, nom, prenom, titre } = useAuthData();
  const isMobile = useIsMobile();

  const greeting = useMemo(() => formatUserGreeting({
    nom: fixTextEncoding(nom),
    prenom: fixTextEncoding(prenom),
    titre: fixTextEncoding(titre),
  }), [user]);

  return (
    <nav className={`navbar px-6 py-1${sidebarOpen && !isMobile ? " sidebar-open" : ""}`}>
      <div className="flex items-center w-full gap-4">
        {/* Zone 1 : Texte à gauche */}
        <div className="flex items-center gap-2 flex-shrink-0">
          {!sidebarOpen && (
            <SeericButton
              onClick={onMenuClick}
              aria-label="Toggle menu"
              className="w-12 h-12 group relative"
              type="button"
              variant="ghost"
              tabIndex={0}
            >
              <Menu />
            </SeericButton>
          )}
          {!isMobile && (
            <span className="navbar-greeting">
              Bonjour{greeting && <>, <span className="font-bold">{greeting}</span></>}
            </span>
          )}
        </div>

        {/* Zone 2 : Input centré */}
        <div className="flex-1 flex items-center">
          <InfoTooltip
            text={'Recherche à effectuer sur un de ces 3 éléments : Référence ' + SITE_NAME_CAPITALIZED + ', Votre référence, Nom du débiteur.'}
            variant="white"
          />
          <div className="flex w-full gap-2" data-tut="test">
            {" "}
            {/* Utilise flex ici */}
            <SeericInput
              name="search"
              value={searchValue}
              onChange={onSearchChange}
              placeholder="Rechercher…"
              className="pl-1 py-2 w-full text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSearchSubmit();
                }
              }}
            />
            <SeericButton
              type="button"
              variant="ghost"
              aria-label="Rechercher"
              tabIndex={1}
              onClick={onSearchSubmit}
              disabled={loading}
            >
              {loading ? (
                <motion.span
                  animate={{ rotate: 360 }}
                  transition={{
                    repeat: Infinity,
                    duration: 1,
                    ease: "linear",
                  }}
                  style={{ display: "inline-block" }}
                >
                  <Search />
                </motion.span>
              ) : (
                <Search />
              )}
            </SeericButton>
          </div>
        </div>

        {/* Zone 3 : Bouton paramètres à droite */}
        {/* <div className="flex-shrink-0">
          <Link href="/settings" passHref>
            <SeericButton
              className="w-12 h-12"
              type="button"
              variant='ghost'
              aria-label="Paramètres"
              tabIndex={2}
            >
              <Settings />
            </SeericButton>
          </Link>
        </div> */}
      </div>
    </nav>
  );
}
